var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocialKakao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9796 30C37.153 30 26 38.3019 26 48.3775C26 54.9205 30.6394 60.6481 37.5986 63.9196L35.2432 72.1033C35.1981 72.2263 35.1909 72.3593 35.2226 72.4861C35.2542 72.613 35.3233 72.7282 35.4215 72.8177C35.5663 72.9353 35.7493 72.9999 35.9384 73C36.0951 72.9889 36.2445 72.9312 36.3662 72.8349L46.5006 66.4742C47.9979 66.6664 49.5053 66.7674 51.0178 66.7748C64.8292 66.7748 76 58.4729 76 48.38C76 38.2847 64.7935 30.0025 50.9822 30.0025L50.9796 30Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialKakao);
export default __webpack_public_path__ + "static/media/ic_social_kakao.2b8373171e0ec963d816925895b1f70d.svg";
export { ForwardRef as ReactComponent };